<div class="hero-banner">
  <div
    data-automation="hero-banner"
    class="container flex align--center justify--center text-center"
  >
    <h1>{{ title }}</h1>
    <p>{{ subTitle }}</p>
  </div>
</div>
